module.exports = __webpack_public_path__ + "static/media/dots.37809195.svg";